import { AuthFeatureState } from '@biz-store/auth/feature.state';
import { createFeatureSelector, createSelector } from '@ngrx/store';
// import { AppFeatureState } from '@biz-store/app/feature.state';
import { SettingsState } from '../store/settings/states/settings.state';
import { FeatureStoreStateKey } from '../store-keys.enum';

// const AppStateSelector = createFeatureSelector<AppFeatureState>(FeatureStoreStateKey.APP);
const AuthStateSelector = createFeatureSelector<AuthFeatureState>(FeatureStoreStateKey.AUTH);
const MainNavSettingsIsLoaded = createSelector(createFeatureSelector<SettingsState>(FeatureStoreStateKey.SETTINGS_FEATURE), (state) => state.mainNavIsLoaded);

// const ClientSelector = createSelector(AppStateSelector, (state) => state.client);
const TokenSelector = createSelector(AuthStateSelector, (state) => state.tokens);
export const CurrentUserSelector = createSelector(AuthStateSelector, (state) => state.currentUser);
// export const Subdomain = createSelector(ClientSelector, (state) => state.subdomain);

export const AuthenticationToken = createSelector(TokenSelector, (state) => state.l7);

export const IsAuthenticated = createSelector(TokenSelector, (state) => state.isAuthenticated);
export const IsSuperAdmin = createSelector(CurrentUserSelector, (user) => user.id === 1);
export const CurrentUserId = createSelector(CurrentUserSelector, (user) => user.id);

// export const CurrentUser = createSelector(AppStateSelector, (state) => state.currentUser);

export const InitialLoadComplete = createSelector(IsAuthenticated, MainNavSettingsIsLoaded, CurrentUserSelector, (isAuthenticated, mainNavIsLoaded, user) => {
	return isAuthenticated && mainNavIsLoaded && !!user;
});

// export { AppIsRouting } from '@biz-store/app/feature.selectors';
